'use client'
import style from '@/app/style/servicesetyle.module.css'
function button() {
  return (
    <div>
        <div className=' mx-auto flex gap-5  max-w-7xl '>
          <div className='transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110'>

          <button className={style.serviceBtn}>Get a Quote</button>
          </div>
          <div className='transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110'>
          <button  className={style.servicebtn2}>Book Now</button>
          </div>
        </div>
      
    </div>
  )
}

export default button
